import { alpha, Box, useTheme } from '@mui/material';
import React from 'react';

const LiveLocationCircle = () => {
    const theme = useTheme();
    const { main, dark } = theme.palette.liveLocation;
    const pulseStrong = alpha(main, 0.6);
    const pulseFade = alpha(main, 0);
    const white = theme.palette.common.white;

    const css = `
    @keyframes livePulse {
        0% { box-shadow: 0 0 0 0 ${pulseStrong}; }
        70% { box-shadow: 0 0 0 6px ${pulseFade}; }
        100% { box-shadow: 0 0 0 0 ${pulseFade}; }
    }

    .live-pulse {
        animation: livePulse 2s infinite;
    }
`;

    return (
        <>
            {' '}
            <style>{css}</style>
            <Box
                component='span'
                className='live-pulse'
                sx={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    background: `radial-gradient(circle at 35% 35%, ${white} 0%, ${main} 50%, ${dark} 100%)`,
                    border: `1px solid ${white}`,
                }}
            />
        </>
    );
};

export default LiveLocationCircle;
